export default __webpack_public_path__ + "static/media/rachel-right.cf3788a7.png";